'use client';

import { CategoriesEntity } from '@eliadmin/core/src/api/general/types/general-layout-types';
import { Category } from '@eliadmin/core/src/api/slugs/types/slug-detail-types';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@eliadmin/core/src/components/ui/accordion';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Link from '@eliadmin/core/src/components/link';

type CategoriesPageNewProps = {
  categories: Category[];
};

export const CategoriesPageNew = ({ categories }: CategoriesPageNewProps) => {
  return (
    <section className={cn('custom-section', 'mt-4 sm:mt-6 lg:mt-8')}>
      <div className={cn('custom-container')}>
        <div className="flex w-full flex-col items-start justify-start gap-4 md:max-w-[700px]">
          <h2
            className={cn(
              'font-heading uppercase',
              'text-3xl font-medium text-foreground sm:text-4xl',
            )}
          >
            KATEGÓRIE
          </h2>
          <Accordion
            type="single"
            collapsible
            className="flex w-full flex-col items-start justify-start gap-0"
          >
            {categories?.map((category, index) => (
              <CategoryItem key={index} category={category} />
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

const CategoryItem = ({ category, layer }: { category: CategoriesEntity; layer?: number }) => {
  const hasChildren = !!category.childs?.length;

  return (
    <AccordionItem
      className={cn('flex flex-col', layer && 'ml-4 w-full border-none')}
      value={category.slug + layer?.toString()}
    >
      <li
        className={cn(
          'flex w-full items-center justify-between border-none bg-transparent px-4 py-2 text-foreground hover:bg-primary hover:text-white',
          'ea-menu-sidebar__list-item',
          layer === 1 && 'ea-sheet-close__layer-1',
          // className?.listItem,
        )}
      >
        <Link
          href={category.slug ?? '#'}
          className={cn(
            'font-heading text-2xl font-medium uppercase',
            layer === 1 && 'text-xl font-medium',
            layer && layer > 1 && 'text-base font-normal',
            category.name === 'Akciová ponuka' && 'text-primary hover:text-white',
          )}
          prefetch={false}
        >
          {category.name}
        </Link>

        {hasChildren && (
          <AccordionTrigger className="h-5 w-5" iconstyles="w-5 h-5 text-primary flex-1" />
        )}
      </li>
      <AccordionContent className="pb-0 ">
        <Accordion type="single" collapsible>
          {hasChildren &&
            category.childs?.map((child, index) => (
              <CategoryItem key={index} category={child} layer={layer ? layer + 1 : 1} />
            ))}
        </Accordion>
      </AccordionContent>
    </AccordionItem>
  );
};
